exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.submitted .form-control.ng-invalid,\r\n.submitted .errorField,\r\n:host >>> .submitted .ng-invalid .ui-calendar .ui-inputtext,\r\n:host >>> .submitted .ng-invalid .ui-dropdown .ui-dropdown-label {\r\n    border-color: #DE6D31 !important;\r\n    background-color: #ffe7e7;\r\n    transition: .3s;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/confirmpasswordsucess/confirmpasswordsucess.component.css
// module id = 1010
// module chunks = 1